import { Link } from 'react-router-dom';

const services = [
  { icon: 'ri-customer-service-line', label: 'Kundengespräch', href: '/kontakt#formular' },
  { icon: 'ri-file-list-3-line', label: 'Angebot', href: '/kontakt#formular' },
  { icon: 'ri-ruler-line', label: 'Aufmaß' },
  { icon: 'ri-shape-line', label: 'Visualisierung & Zeichnung' },
  { icon: 'ri-draft-line', label: 'Planung & Statik' },
  { icon: 'ri-truck-line', label: 'Anlieferung' },
  { icon: 'ri-hammer-line', label: 'Montage' },
  { icon: 'ri-settings-3-line', label: 'Wartung' },
];

export default function Home() {
  return (
    <div className="min-h-screen">
      <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Industrial%20metal%20workshop%20with%20warm%20amber%20lighting%20and%20steel%20beams%2C%20modern%20architectural%20background%2C%20cinematic%20wide%20angle%20composition%2C%20dark%20atmospheric%20tones%20with%20golden%20highlights%2C%20no%20text%2C%20high%20detail%20professional%20photography%2C%20clean%20composition&width=1600&height=900&seq=hero-klosek-2026&orientation=landscape"
          alt="Metallbau Hintergrund"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40" />
        <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4 md:px-6 lg:px-8">
          <h1 className="text-4xl md:text-6xl font-heading font-bold text-background-50 mb-4 drop-shadow-lg">
            Willkommen!
          </h1>
          <p className="text-lg md:text-2xl font-heading text-background-50/90 mb-2">
            Alles aus Metall!
          </p>
          <p className="text-lg md:text-2xl font-heading text-background-50/90 mb-8">
            Alles aus einer Hand!
          </p>
          <Link
            to="/kontakt#formular"
            className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-semibold rounded-md hover:bg-primary-600 transition-colors shadow-lg"
          >
            <i className="ri-phone-line"></i>
            Jetzt Kontakt aufnehmen
          </Link>
        </div>
      </section>

      <section className="w-full py-16 md:py-24 px-4 md:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <div className="space-y-4 text-foreground-700 text-base md:text-lg leading-relaxed">
            <p>
              Durch langjährige Erfahrung unserer Mitarbeiter bieten wir Ihnen höchste Fachkompetenz und ermöglichen es die Wünsche unserer Kunden schnell und qualitativ hochwertig umzusetzen.
            </p>
            <p>
              Wir verwirklichen all Ihre Ideen aus Metall.
            </p>
            <p>
              Vom Kundengespräch über eine Visualisierung bis hin zur Montage stehen wir Ihnen natürlich gerne mit vollster Aufmerksamkeit zur Verfügung.
            </p>
            <p>
              Durch CAD-Zeichnungen bieten wir unseren Kunden eine sehr genaue Vorstellung über das Bauvorhaben.
            </p>
            <p>
              Wir freuen uns auf Sie!
            </p>
          </div>
        </div>
      </section>

      <section className="w-full py-12 md:py-16 bg-background-100 px-4 md:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 md:gap-8">
            {services.map((service, index) => {
              const inner = (
                <div className="flex flex-col items-center text-center group">
                  <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full bg-background-50 shadow-sm mb-4 group-hover:shadow-md transition-shadow">
                    <i className={`${service.icon} text-2xl md:text-3xl text-primary-500`}></i>
                  </div>
                  <span className="text-sm md:text-base font-semibold text-foreground-800">
                    {service.label}
                  </span>
                </div>
              );
              return service.href ? (
                <Link key={index} to={service.href} className="block">
                  {inner}
                </Link>
              ) : (
                <div key={index} className="block">
                  {inner}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="w-full py-12 md:py-16 px-4 md:px-6 lg:px-8">
        <div className="max-w-md mx-auto">
          <a
            href="tel:023515691455"
            className="flex items-center justify-center gap-3 w-full px-8 py-4 bg-primary-500 text-background-50 font-semibold text-lg rounded-md hover:bg-primary-600 transition-colors shadow-md"
          >
            <i className="ri-phone-line text-xl"></i>
            <span>Rufen Sie uns an</span>
            <span className="font-mono text-base opacity-90">02351 5691455</span>
          </a>
        </div>
      </section>

      <section className="w-full py-12 md:py-16 bg-background-100 px-4 md:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 items-center justify-items-center">
            <div className="flex flex-col items-center gap-3">
              <img
                src="https://cdn.website-editor.net/7d8ac7c335184250b23ba42ef856ef8e/dms3rep/multi/img_din1090.png"
                alt="Zertifiziert nach DIN EN 1090"
                className="h-32 w-auto object-contain"
                loading="lazy"
              />
              <span className="text-sm font-medium text-foreground-700 text-center">
                Zertifiziert nach DIN EN 1090
              </span>
            </div>
            <div className="flex flex-col items-center gap-3">
              <img
                src="https://cdn.website-editor.net/7d8ac7c335184250b23ba42ef856ef8e/dms3rep/multi/Siegel_Meisterbetrieb.png"
                alt="Meisterbetrieb"
                className="h-32 w-auto object-contain"
                loading="lazy"
              />
              <span className="text-sm font-medium text-foreground-700 text-center">
                Wir sind ein Meisterbetrieb
              </span>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full py-12 md:py-16 px-4 md:px-6 lg:px-8">
        <div className="max-w-md mx-auto flex flex-col gap-4">
          <a
            href="https://cdn.website-editor.net/s/7d8ac7c335184250b23ba42ef856ef8e/files/uploaded/Schwei%C3%9Fzertifikat%202023.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-3 w-full px-6 py-3.5 border-2 border-primary-500 text-primary-500 font-semibold rounded-md hover:bg-primary-500 hover:text-background-50 transition-colors"
          >
            <i className="ri-star-line"></i>
            <span>Schweißzertifikat</span>
          </a>
          <a
            href="https://cdn.website-editor.net/s/7d8ac7c335184250b23ba42ef856ef8e/files/uploaded/Zertifikat%201090%202023.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-3 w-full px-6 py-3.5 border-2 border-primary-500 text-primary-500 font-semibold rounded-md hover:bg-primary-500 hover:text-background-50 transition-colors"
          >
            <i className="ri-star-line"></i>
            <span>Zertifikat über werkseigene Produktionskontrolle</span>
          </a>
        </div>
      </section>
    </div>
  );
}